import { render } from "./adminDashboard.vue?vue&type=template&id=3a511b90&scoped=true"
import script from "./adminDashboard.vue?vue&type=script&lang=js"
export * from "./adminDashboard.vue?vue&type=script&lang=js"

import "./adminDashboard.vue?vue&type=style&index=0&id=3a511b90&scoped=true&lang=scss"

import exportComponent from "/srv/sites/eservice.talronbatt.co.il/api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a511b90"]])

export default __exports__